import LRUCache from "lru-cache"

// 刷新页面、路由跳转都会使得LRUCache重新被实例化, 故缓存到进程对象中
const lruCache =
  process.__Cache__ ||
  (process.__Cache__ = new LRUCache({
    max: 100, // 最大缓存项数量
    maxAge: 1000 * 60 * 60 // 每个缓存项的最大存活时间（毫秒）
  }))

export default lruCache
